import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, MessageCircle } from "lucide-react";
export default function GetStartedCta() {
  return;
}